/**
 * Envío UI-2 · "Resultados del canvas" en la Vista Edición.
 * Junta lo que ya generaron los nodos (data.outputUrl) para mandarlo al
 * timeline con un clic. Función pura: no toca el store.
 */
const VIDEO_RE = /\.(mp4|webm|mov|m4v)(\?|#|$)/i;
const AUDIO_RE = /\.(mp3|wav|m4a|aac|ogg|flac)(\?|#|$)/i;
const KINDS = new Set(['image', 'video', 'audio']);

export function inferKind(url, declared) {
  if (declared && KINDS.has(declared)) return declared;
  if (!url) return null;
  if (VIDEO_RE.test(url)) return 'video';
  if (AUDIO_RE.test(url)) return 'audio';
  return 'image';
}

const nodeNum = (id) => {
  const m = /(\d+)$/.exec(String(id || ''));
  return m ? Number(m[1]) : Number.MAX_SAFE_INTEGER;
};

/**
 * @param {Array} nodes  nodos de ReactFlow (workflowStore.nodes)
 * @returns {Array<{key,nodeId,label,kind,url,assetId,thumb}>}
 *   Un ítem por archivo (si un nodo "Vista previa" repite la salida de otro,
 *   queda el del nodo que la generó). Ordenado por número de nodo.
 */
export function collectCanvasResults(nodes) {
  const byUrl = new Map();
  [...(nodes || [])]
    .sort((a, b) => nodeNum(a?.id) - nodeNum(b?.id))
    .forEach((n) => {
      const d = n?.data || {};
      const url = typeof d.outputUrl === 'string' ? d.outputUrl : null;
      if (!url) return;
      const kind = inferKind(url, d.outputType);
      if (!kind) return;
      const prev = byUrl.get(url);
      const isPreview = n.type === 'outputPreview';
      if (prev && (isPreview || !prev.fromPreview)) return;
      byUrl.set(url, {
        key: `${n.id}:${url}`,
        nodeId: n.id,
        label: (d.name && String(d.name).trim()) || `Nodo ${nodeNum(n.id)}`,
        kind,
        url,
        assetId: d.assetId || null,
        thumb: kind === 'image' ? (d.preview || url) : null,
        fromPreview: isPreview,
      });
    });
  return [...byUrl.values()].map(({ fromPreview, ...it }) => it);
}
